export default __webpack_public_path__ + "static/media/onboarding-background.3e6fcd93.svg";